export class AuthModel {
  authToken: string = '';
  refreshToken: string = '';
  expiresIn: Date = new Date(); // Assign a default value to expiresIn property

  setAuth(auth: AuthModel) {
    this.authToken = auth.authToken;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
  }
}
